import {
  AfterViewInit,
  Directive,
  ElementRef,
  Input,
  Optional,
} from '@angular/core';
import { RouterLinkWithHref } from '@angular/router';

@Directive({
  selector: '[externalLink]',
})
export class ExternalLinkDirective implements AfterViewInit {
  @Input() public externalLink: string;

  constructor(
    // Inject RouterLinkWithHref
    @Optional() private link: RouterLinkWithHref,
    private elRef: ElementRef
  ) {
    if (!link) {
      return;
    }

    // Save original onClick method
    const onClick = link.onClick;

    // Replace method with your own
    link.onClick = (...args: any[]) => {
      if (this.externalLink) {
        // Process external url
        window.open(this.externalLink, '_blank');
        return false;
      } else {
        // Process internal url by calling routerLink original method
        return onClick.apply(link, args);
      }
    };
  }

  public ngAfterViewInit() {
    if (
      this.externalLink &&
      this.elRef.nativeElement instanceof HTMLAnchorElement
    ) {
      // Change href attribute of existing link
      this.elRef.nativeElement.href = this.externalLink;
    }
  }
}
